import CoursesNavbar from "../components/CoursesNavbar";
import CertificateSection from "../components/CertificateSection";
import GetAdmissionForm from "../components/GetAdmissionForm";
import TrainingFooter from "../components/Tranining Footer";
import IndustryShowcase2 from "../components/IndustryShowcase2";
import FAQSection from "../components/FAQSection";
import TopSplitSection from "../components/TopSplitSection";
import MeetInstructors from "../components/MeetInstructors";

export default function AboutUs() {

  return (
    <>
      <CoursesNavbar />

      {/* Hero Section */}
      <div
        style={{
          background: "linear-gradient(to right, #0066cc, #3399ff)",
          padding: "100px 20px",
          color: "#fff",
          textAlign: "center",
        }}
      >
        <h1 style={{ fontSize: "38px", fontWeight: "bold" }}>About Us</h1>
        <p style={{ fontSize: "18px", marginTop: "10px" }}>
          Learn more about JK Associates and our values.
        </p>
      </div>

      {/* About JK Associates Section with Bottom Left Radius */}
      <div
  style={{
    backgroundColor: "#f0f8ff",
    borderBottomLeftRadius: "80px",
    padding: "60px 20px",
  }}
>
  <div
    style={{
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "space-between",
      maxWidth: "1200px",
      margin: "0 auto",
      alignItems: "center",
      gap: "40px",
    }}
  >
    <div style={{ flex: "1 1 500px" }}>
      <h2 style={{ color: "#0066cc", fontWeight: "bold", marginBottom: "20px" }}>
        About the JK Associates
      </h2>
      <p style={{ fontSize: "16px", lineHeight: "1.7", color: "#333" }}>
        JK Associates is a trusted consultancy firm specializing in business solutions and legal
advisory services. Since our inception, we have empowered countless businesses with expert
guidance in company formation, trademark registration, compliance, and more.
JK Associates is proud to launch a comprehensive skill development program designed to
help you Learn, Earn, and Grow. Whether you are a beginner or looking to enhance your
professional expertise, this program offers hands-on training, practical knowledge, and
lifetime expert support to guide your journey toward success.
Step into the future of learning with JK Associates — where skills meet opportunity!
      </p>
    </div>
    <div style={{ flex: "1 1 400px" }}>
      <img
        src={require("../assets/images/class-2.jpg")}
        alt="About JK"
        style={{
          width: "100%",
          borderRadius: "20px",
          boxShadow: "0 8px 24px rgba(0,0,0,0.1)"
        }}
      />
    </div>
  </div>
</div>

      {/* Industry Showcase */}
      <IndustryShowcase2 />

      {/* Green Mission and Vision Section */}
      <section
        style={{
          background: "linear-gradient(90deg, #4caf50, rgb(56, 172, 60))",
          padding: "100px 20px",
          position: "relative",
          marginBottom: "100px",
        }}
      >
        <div className="text-center text-white" style={{ maxWidth: "1200px", margin: "auto" }}>
          <p className="mb-0 fw-semibold" style={{ fontSize: "20px", lineHeight: "1.5" }}>
            From 2017, JK Associates is a highly regarded law and consultancy firm with over 550 clients and outstanding reviews, known for delivering exceptional legal services in Bangladesh and beyond.
          </p>
        </div>

        <div className="container" style={{ position: "relative", marginTop: "50px" }}>
          <div className="row justify-content-center">
            {/* Mission */}
            <div className="col-12 col-md-5 mb-4 mb-md-0">
              <div
                className="p-4 rounded shadow-sm text-center"
                style={{
                  backgroundColor: "#fff9f0",
                  borderRadius: "12px",
                }}
              >
                <h3 className="fw-bold" style={{ color: "#4caf50", fontSize: "1.5rem" }}>
                  Mission
                </h3>
                <p className="text-muted mt-3">
                  To transform learning into opportunity, delivering high-quality, trusted, and innovative education
solutions that empower students and insritutions to achieve lasting success.
                </p>
              </div>
            </div>

            {/* Vision */}
            <div className="col-12 col-md-5">
              <div
                className="p-4 rounded shadow-sm text-center"
                style={{
                  backgroundColor: "#fff9f0",
                  borderRadius: "12px",
                }}
              >
                <h3 className="fw-bold" style={{ color: "#4caf50", fontSize: "1.5rem" }}>
                  Vision
                </h3>
                <p className="text-muted mt-3">
                  To empower learners and entrepreneurs worldwide with practical knowledge and lifelong support,
creating a future of confident, skilled, and independent professionals.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Why Chartered Skills Section (Direct, no component) */}
      <section
        style={{
          backgroundColor: "#f0f8ff",
          borderTopLeftRadius: "100px",
          padding: "80px 20px",
          marginBottom: "60px",
        }}
      >
        <div style={{ maxWidth: "1100px", margin: "0 auto" }}>
          <h3
            style={{
              color: "#0066cc",
              fontSize: "28px",
              fontWeight: "bold",
              marginBottom: "20px",
              textAlign: "center",
            }}
          >
            Why Chartered Skills
          </h3>

          <p style={{ fontSize: "16px", lineHeight: "1.7", color: "#333" }}>
            JK Associates Training is designed to empower learners with practical skills, industry knowledge, and
professional con-dence. Whether you are a beginner or looking to enhance your expertise, our
programs o2er hands-on learning, expert mentorship, and career-focused guidance. With accredited certification and lifetime support, we ensure that your learning journey continues long a1er the course
ends. At JK Associates, we turn knowledge into real-world opportunities, helping you learn, earn, and
grow in today’s competitive market.
          </p>

        </div>
      </section>

      {/* Advisor Section */}
      <section className="py-5 bg-light" style={{ position: "relative" }}>
  {/* Top Left Radius Section */}

</section>

      {/* Final Sections */}
      <TopSplitSection/>
      <CertificateSection />
      < MeetInstructors/>
      <FAQSection/>
      <GetAdmissionForm />
      <TrainingFooter />
    </>
  );
}
